export const AUTHENTICATION_STATE_KEY = "AUTHENTICATION_STATE";

export const getListeningNames = (state: Record<string, unknown>[]): any => {
    return [...state[AUTHENTICATION_STATE_KEY].listening.keys()];
};
